import React, { Suspense, lazy } from 'react';
// Notice the usage of BrowserRouter and Routes here!
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CoworkingPage } from './components/CoworkingPage';
import { MemberHomePage } from './components/MemberHomePage';
import { Navbar } from './components/Navbar';
import { PublicProfilePage } from './components/PublicProfilePage';
import { ProfileSettingsPage } from './components/ProfileSettingsPage';
import './styles/fonts.css';
// Lazy load ConnectionsPage for better performance
const ConnectionsPage = lazy(() => import('./components/ConnectionsPage').then(module => ({
  default: module.ConnectionsPage
})));
// Lazy load NetworkingPage for better performance
const NetworkingPage = lazy(() => import('./components/NetworkingPage').then(module => ({
  default: module.NetworkingPage
})));
// Lazy load NetworkingDetailPage for better performance
const NetworkingDetailPage = lazy(() => import('./components/NetworkingDetailPage').then(module => ({
  default: module.NetworkingDetailPage
})));
// Lazy load RandomNetworkPage for better performance
const RandomNetworkPage = lazy(() => import('./components/RandomNetworkPage').then(module => ({
  default: module.RandomNetworkPage
})));
// Lazy load EventsPage for better performance
const EventsPage = lazy(() => import('./components/EventsPage').then(module => ({
  default: module.EventsPage
})));
// Lazy load CollaborationPage for better performance
const CollaborationPage = lazy(() => import('./components/CollaborationPage').then(module => ({
  default: module.CollaborationPage
})));
// Lazy load ImpactPage for better performance
const ImpactPage = lazy(() => import('./components/ImpactPage').then(module => ({
  default: module.ImpactPage
})));
// Shared fallback component to prevent flash of white screen
const PageLoadingFallback = () => <div className="flex flex-col min-h-screen w-full bg-white text-black font-sans pt-6 animate-fade-in" data-id="element-0">
    <div className="max-w-6xl mx-auto px-4 md:px-6 w-full" data-id="element-1">
      <div className="h-8 w-64 bg-gray-200 rounded-md mb-6 animate-pulse" data-id="element-2"></div>
      <div className="h-10 w-full bg-gray-200 rounded-lg mb-8 animate-pulse" data-id="element-3"></div>
      <div className="grid grid-cols-1 gap-4" data-id="element-4">
        {[1, 2, 3, 4].map(i => <div key={i} className="bg-gray-200 rounded-lg h-32 animate-pulse" data-id="element-5"></div>)}
      </div>
    </div>
  </div>;
export function App() {
  return <BrowserRouter data-id="element-6">
      <div className="px-4 sm:px-6 md:px-8 lg:px-10 max-w-screen-2xl mx-auto" data-id="element-7">
        <Navbar data-id="element-8" />
        <Routes data-id="element-9">
          <Route path="/" element={<MemberHomePage data-id="element-11" />} data-id="element-10" />
          <Route path="/coworking" element={<CoworkingPage data-id="element-13" />} data-id="element-12" />
          <Route path="/connections" element={<Suspense fallback={<PageLoadingFallback data-id="element-16" />} data-id="element-15">
                <ConnectionsPage data-id="element-17" />
              </Suspense>} data-id="element-14" />
          <Route path="/networking" element={<Suspense fallback={<PageLoadingFallback data-id="element-20" />} data-id="element-19">
                <NetworkingPage data-id="element-21" />
              </Suspense>} data-id="element-18" />
          <Route path="/networking/random" element={<Suspense fallback={<PageLoadingFallback data-id="element-24" />} data-id="element-23">
                <RandomNetworkPage data-id="element-25" />
              </Suspense>} data-id="element-22" />
          <Route path="/networking/:mode" element={<Suspense fallback={<PageLoadingFallback data-id="element-28" />} data-id="element-27">
                <NetworkingDetailPage data-id="element-29" />
              </Suspense>} data-id="element-26" />
          <Route path="/events" element={<Suspense fallback={<PageLoadingFallback data-id="element-32" />} data-id="element-31">
                <EventsPage data-id="element-33" />
              </Suspense>} data-id="element-30" />
          <Route path="/collaboration" element={<Suspense fallback={<PageLoadingFallback data-id="element-36" />} data-id="element-35">
                <CollaborationPage data-id="element-37" />
              </Suspense>} data-id="element-34" />
          <Route path="/impact" element={<Suspense fallback={<PageLoadingFallback data-id="element-40" />} data-id="element-39">
                <ImpactPage data-id="element-41" />
              </Suspense>} data-id="element-38" />
          <Route path="/profile/:username" element={<div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] -mt-[92px]" data-id="element-43">
                <PublicProfilePage data-id="element-44" />
              </div>} data-id="element-42" />
          <Route path="/profile/settings" element={<ProfileSettingsPage data-id="element-46" />} data-id="element-45" />
        </Routes>
      </div>
    </BrowserRouter>;
}